export default __webpack_public_path__ + "static/media/placeholder_dummy2016-irishpub01-de.b69133fe.png";